import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getNaturezasOrcamentarias({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/filhos/${filters.codCCustoFilho}/naturezas-orcamentarias`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async saveAssociacaoNaturezaOrcamentaria({ commit }, data) {
      try {
        return await api.post(
          `/centros-custos/${data.codCCustoPai}/filhos/${data.codCCustoFilho}/naturezas-orcamentarias/associar`,
          data.naturezaOrcamentaria,
        )
      } catch (error) {
        throw error
      }
    },

    async getNaturezasOrcamentariasSemAssociacao({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/filhos/${filters.codCCustoFilho}/naturezas-orcamentarias/sem-associacao`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
